(function() {
    "use strict";

    const $ = require('jquery');
    const uniqueId = require('./uniqueId');

    function ezBSAlert(options) {
        let deferredObject = $.Deferred();
        let defaults = {
            id: uniqueId(),
            type: "alert", //alert, prompt,confirm
            modalSize: 'modal-sm', //modal-sm, modal-lg
            okButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            yesButtonText: 'Yes',
            noButtonText: 'No',
            headerText: 'Attention',
            messageText: 'Message',
            alertType: 'default', //default, primary, success, info, warning, danger
            inputFieldType: 'text', //could ask for number,email,etc
        };
        $.extend(defaults, options);

        const _show = function () {
            let headClass = "navbar-default";
            switch (defaults.alertType) {
                case "primary":
                    headClass = "alert-primary";
                    break;
                case "success":
                    headClass = "alert-success";
                    break;
                case "info":
                    headClass = "alert-info";
                    break;
                case "warning":
                    headClass = "alert-warning";
                    break;
                case "danger":
                    headClass = "alert-danger";
                    break;
            }
            $('body').append(
                `<div id="` + defaults.id + `" class="modal fade">
                    <div class="modal-dialog ` + defaults.modalSize + `">
                        <div class="modal-content">
                            <div class="modal-header ` + headClass + `">
                                <button type="button" class="close" data-dismiss="modal">
                                    <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                                </button>
                                <h4 class="modal-title">Modal title</h4>
                            </div>
                            <div class="modal-body">
                                <div class="modal-text"></div>
                            </div>
                            <div class="modal-footer"></div>
                        </div>
                    </div>
                </div>`
            );

            const ezModal = $('#' + defaults.id);
            const ezTitle = ezModal.find('.modal-title');
            const ezMessage = ezModal.find('.modal-text');
            const ezFooter = ezModal.find('.modal-footer');
            ezModal.find('.modal-header').css({
                'padding': '15px 15px',
                '-webkit-border-top-left-radius': '5px',
                '-webkit-border-top-right-radius': '5px',
                '-moz-border-radius-topleft': '5px',
                '-moz-border-radius-topright': '5px',
                'border-top-left-radius': '5px',
                'border-top-right-radius': '5px'
            });
            ezTitle.text(defaults.headerText);
            ezMessage.html(defaults.messageText);

            let keyb = "false";
            let backd = "static";
            let callbackParam = "";
            switch (defaults.type) {
                case 'alert':
                    keyb = "true";
                    backd = "true";
                    ezFooter.html('<button class="btn btn-' + defaults.alertType + '">' + defaults.okButtonText + '</button>').on('click', ".btn", function () {
                        callbackParam = true;
                        ezModal.modal('hide');
                    });
                    break;
                case 'confirm':
                    let btnhtml = '<button id="ezok-btn" class="btn btn-primary">' + defaults.yesButtonText + '</button>';
                    if (defaults.noButtonText && defaults.noButtonText.length > 0) {
                        btnhtml += '<button id="ezclose-btn" class="btn btn-default">' + defaults.noButtonText + '</button>';
                    }
                    ezFooter.html(btnhtml).on('click', 'button', function (e) {
                        if (e.target.id === 'ezok-btn') {
                            callbackParam = true;
                            ezModal.modal('hide');
                        } else if (e.target.id === 'ezclose-btn') {
                            callbackParam = false;
                            ezModal.modal('hide');
                        }
                    });
                    break;
                case 'prompt':
                    ezMessage.html(defaults.messageText + '<br /><br /><div class="form-group"><input type="' + defaults.inputFieldType + '" class="form-control modal-prompt" /></div>');
                    ezFooter.html('<button class="btn btn-primary">' + defaults.okButtonText + '</button>').on('click', ".btn", function () {
                        callbackParam = ezModal.find('.modal-prompt').val();
                        ezModal.modal('hide');
                    });
                    break;
            }

            ezModal.modal({
                show: false,
                backdrop: backd,
                keyboard: keyb
            }).on('hidden.bs.modal', function (e) {
                ezModal.remove();
                deferredObject.resolve(callbackParam);
            }).on('shown.bs.modal', function (e) {
                const prompt = ezModal.find('.modal-prompt');
                if (prompt.length > 0) {
                    prompt.focus();
                }
            }).modal('show');
        };

        _show();
        return deferredObject.promise();
    }

    module.exports = ezBSAlert;
})();


// WEBPACK FOOTER //
// ./resources/scripts/utils/ezBSAlert.js